import { ChangeDetectionStrategy, Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatChipListbox, MatChipListboxChange, MatChipOption } from '@angular/material/chips';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { EnpsComponent } from '@common/components/base/enps-component';
import { ViewStateFilterStates } from '@common/enums/viewstate-filter-states';
import { ViewStateFilterVisibility } from '@common/enums/viewstate-filter-visibility';
import { ViewStateLayouts } from '@common/enums/viewstate-layouts';
import { ViewStateTypes } from '@common/enums/viewstate-types';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { LanguageSettings } from '@common/services/language-settings';
import { VisualStateService } from '@common/services/visual-state-service';
import { Store } from '@ngrx/store';
import { TeamScope, ViewStateTypeNames } from '@src/suite/common/enums/enums';
import { ViewStateService } from '@src/suite/common/services/view-state-service';
import { ViewStateActions, ViewStateApiActions } from '@src/suite/common/store/navigation/actions/viewstate.actions';
import { selectCurrentApplication } from '@src/suite/common/store/navigation/selectors/navigation.selectors';
import { AppService } from '@suite/app.service';

import { StaffIDListMultipleComponent } from '../../../controls/staff-id-list/staff-id-list-multiple';
import { ClickStopPropagationDirective } from '../../../directives/stop-propagation';

@Component({
    selector: 'st-filter-planning-views',
    imports: [
        ClickStopPropagationDirective,
        FormsModule,
        MatAccordion,
        MatChipListbox,
        MatChipOption,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        StaffIDListMultipleComponent,
    ],
    templateUrl: './filter-planning-views.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class FilterPlanningViewsComponent extends EnpsComponent {
    appService = inject(AppService);
    layoutState = inject(ViewStateService);
    languageSettings = inject(LanguageSettings);
    globalTablesService = inject(GlobalTablesService);
    visualStateService = inject(VisualStateService);

    private store = inject(Store);
    public viewStateTypes = ViewStateTypes;
    public viewStateFilterStates = ViewStateFilterStates;
    public viewStateLayouts = ViewStateLayouts;
    public viewStateFilterVisibility = ViewStateFilterVisibility;

    public filterViewStateTypes: { ViewStateType: number; ViewStateTypeName: string }[] = [
        { ViewStateType: -1, ViewStateTypeName: 'All' },
        { ViewStateType: ViewStateTypes.TOPIC, ViewStateTypeName: ViewStateTypeNames.TOPIC },
        { ViewStateType: ViewStateTypes.ASSIGNMENT, ViewStateTypeName: ViewStateTypeNames.ASSIGNMENT },
        { ViewStateType: ViewStateTypes.SCRIPT, ViewStateTypeName: ViewStateTypeNames.SCRIPT },
        { ViewStateType: ViewStateTypes.SEARCH, ViewStateTypeName: ViewStateTypeNames.SEARCH },
        { ViewStateType: ViewStateTypes.LIVESEARCH, ViewStateTypeName: ViewStateTypeNames.SEARCH },
        { ViewStateType: ViewStateTypes.WIRESEARCH, ViewStateTypeName: ViewStateTypeNames.SEARCH },
    ];

    readonly group = signal<string>(TeamScope.ALL);

    public all = TeamScope.ALL;
    public global = TeamScope.GLOBAL;
    public personal = TeamScope.PERSONAL;

    application = this.store.selectSignal(selectCurrentApplication);

    constructor() {
        super();

        this.teams = this.globalTablesService.getListItemsForTeamLocations();
    }

    public teams = [];

    readonly creators = signal<string[]>([]);

    public async onTeamChange(event: MatChipListboxChange) {
        this.group.set(event.value);
        this.store.dispatch(ViewStateApiActions.loadViewStateRecords({ group: this.group(), application: this.application(), creators: this.creators() }));
    }

    public async onCreatorChange(value: string[]) {
        this.creators.set(value);
        this.store.dispatch(ViewStateApiActions.loadViewStateRecords({ group: this.group(), application: this.application(), creators: this.creators() }));
    }

    public toggle() {
        this.store.dispatch(ViewStateActions.togglePlanningViewsFilterState());
    }
}
